module.exports = __webpack_public_path__ + "static/media/defaultLink.7cfe3adf.svg";